import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Command, CommandCreate, CommandUpdate } from '../../../shared/interfaces/click.interfaces';

const basePath = '/click/commands';

@Injectable({
  providedIn: 'root'
})

export class ClickCommandsService {
  constructor(private http: HttpClient) { }

  // Get all commands from current and parent dealers
  getCommands(): Observable<Command[]> {
    return this.http.get<Command[]>(`${basePath}`);
  }

  // Creates a new command for the current dealer
  createCommand(payload: CommandCreate): Observable<Command> {
    // const body = payload
    const body = {
      "name": payload.name,
      "icon_color": payload.icon_color,
      "icon_type": payload.icon_type,
      "icon": payload.icon,
      "description": payload.description,
      "actions": payload.actions
    }
    return this.http.post<Command>(`${basePath}`, body);
  }

  // Updates a command for the current dealer
  updateCommand(payload: CommandUpdate): Observable<any> {
    const body = payload
    return this.http.put<any>(`${basePath}`, body);
  }

  // Get details of a specific command
  getCommandById(id: number): Observable<Command> {
    return this.http.get<Command>(`${basePath}/${id}`);
  }

  // Deletes a specific command
  deleteCommand(id: number): Observable<any> {
    return this.http.delete<any>(`${basePath}/${id}`);
  }
}
